// Browser ESM entry (`serpsize/core`): the engine plus the pure layer, with the built-in profiles.

import { builtinFonts, builtinOrder, builtinProfiles } from 'serpsize:profiles';
import { ProfileSet } from './profiles';

export * from './types';
export * from './text';
export * from './config';
export * from './profiles';
export * from './assemble';
export * from './engine';
export * from './fonts';
export * from './measure';
export * from './check';
export * from './format/outputs';
export { builtinFonts, builtinOrder, builtinProfiles };

export function builtinProfileSet(): ProfileSet {
  return new ProfileSet(builtinProfiles, builtinFonts, builtinOrder);
}
